module.exports = __webpack_public_path__ + "img/cert7.41ead99e.png";